module.exports = __webpack_public_path__ + "assets/img/btn_draw_ten.e6d82efe.png";